import { render, staticRenderFns } from "./BCXFloatingNavigation.vue?vue&type=template&id=2a67ef46&scoped=true"
import script from "./BCXFloatingNavigation.vue?vue&type=script&lang=ts"
export * from "./BCXFloatingNavigation.vue?vue&type=script&lang=ts"
import style0 from "./BCXFloatingNavigation.vue?vue&type=style&index=0&id=2a67ef46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a67ef46",
  null
  
)

export default component.exports